
























import { dayjs, DTW_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { MessageDialog } from '../../utils/MessageDialog';

import { Vue, Component, Prop } from 'vue-property-decorator';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import { routeHelper } from '../../utils/routeHelper';

@Component({
  components: {},
  filters: {
    dateFormat(value: string): string {
      if (!value) return '';
      return dayjs(value).format(DTW_FORMAT_JA);
    },
  },
})
export default class LessonStateCard extends Vue {
  @Prop()
  row!: LessonDTO;

  getStateColor(state: string) {
    return LessonStates.getBadgeClassByState(state);
  }

  get isReportSent() {
    return this.row.lessons.reservation_state === LessonStates.ALREADY;
  }

  get isPast() {
    return dayjs(this.row.lessons.start_dt).diff(dayjs()) < 0;
  }

  async change() {
    this.$emit('transfer', this.row);
  }
  supportPlan() {
    if (!this.row.student?.user_id) {
      MessageDialog.systemError('生徒ユーザーID', '個別支援計画への遷移時', this.row.student?.user_id).then();
      return;
    }
    routeHelper(this, 'SupportPlanPageFroTeacher', { user_id: this.row.student?.user_id });
  }
  gotoDailyReport() {
    if (!this.row.lessons?.class_id) {
      MessageDialog.systemError('レッスンID', '日報への遷移時', this.row.lessons?.class_id).then();
      return;
    }
    routeHelper(this, 'TeacherDailyReportPage', { class_id: this.row.lessons?.class_id.toString() });
  }
}
